import { centroid } from "@thi.ng/geom-poly-utils";
import { comp, map, partition, push, transduce, wrapSides, zip, } from "@thi.ng/transducers";
import { mixN } from "@thi.ng/vectors";
export const tesselInset = (inset = 0.5, keepInterior = false) => (points) => {
    const c = centroid(points);
    const inner = points.map((p) => mixN([], p, c, inset));
    return transduce(comp(partition(2, 1), map(([[a, b], [c, d]]) => [a, b, d, c])), push(), keepInterior ? [inner] : [], wrapSides([...zip(points, inner)], 0, 1));
};
